export const isOneYear = id => id >= 366 && id < 373;
export const isTwoYear = id => id >= 730 && id < 737;
